import { CalculationDto } from '../../api/models/calculation-dto';
import { RoofProducerEnum } from '../../api/models/roof-producer-enum';
import { RoofProductTypeEnum } from '../../api/models/roof-product-type-enum';

export class ProductsMetaService {
  static baseImageUrl = 'https://expert-roof-systems.s3.eu-central-1.amazonaws.com/';
  static getTileProductNameFromCalculation(calculation: CalculationDto): string {
    if (!calculation.color) {
      return '';
    }
    let name = `${calculation.color.thickness.finish.product.name} ${calculation.color.thickness.finish.finish} ${calculation.color.thickness.thickness} ${calculation.color.color}`;
    if (calculation.hasDripStop) {
      name += ' cu dripstop';
    }

    return name;
  }

  static getImagePath(
    type: RoofProductTypeEnum,
    producer: string,
    name: string,
    finish: string,
    color: string,
  ): string {
    const formattedFinish = finish
      .toLowerCase()
      .replace('8003', '')
      .replace('neomat 30', 'neomat')
      .replace('suprem 50', 'suprem')
      .replace(' dublu vopsit', '')
      .replace(' ', '')
      .trim();
    let formattedName = name.toLowerCase().replace('drip stop', '').replace('dripstop', '').trim();
    if (formattedName.includes('retropanel')) {
      formattedName = 'retropanel';
    } else if (formattedName === 'clasic 20' || formattedName === 'clasic 15') {
      formattedName = 'clasic';
    } else if (formattedName.includes('dx51')) {
      formattedName = 'tabla faltuita dx51';
    }
    let producerPath = type === RoofProductTypeEnum.FenceSlats ? 'Bilka/' : '';
    if (producer === RoofProducerEnum.Wetterbest) {
      producerPath = 'wetterbest/';
    }

    return `https://expert-roof-systems.s3.eu-central-1.amazonaws.com/${
      type === RoofProductTypeEnum.Tile ? 'tiles' : type
    }/${producerPath}${formattedName}/${formattedFinish}-${color}.webp`;
  }

  static getRainSystemImagePath(producer: RoofProducerEnum, finish: string, color: string): string {
    if (!finish || !color) {
      return '';
    }
    if (finish.toLowerCase() === 'magnelis') {
      color = 'magneziu';
    }
    finish = finish.replace(' ', '-').toLowerCase();
    if (producer === RoofProducerEnum.Wetterbest) {
      return `https://expert-roof-systems.s3.eu-central-1.amazonaws.com/accessories/wetterbest/rain-system/${color}.webp`;
    }
    return `https://expert-roof-systems.s3.eu-central-1.amazonaws.com/accessories/rain-system/${finish}-${color}.webp`;
  }

  static getProductNameUrlFriendly(name: string, producer: string): string {
    return (producer + '-' + name).toLowerCase().replace(/\s+/g, '-').replace(/-+/g, '-');
  }
}
